module.exports = __webpack_public_path__ + "static/media/image_10.164a2ce1.png";